import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-card-upload',
  templateUrl: './card-upload.component.html',
  styleUrls: ['./card-upload.component.scss']
})
export class CardUploadComponent {
  @Input() card: string = '';
  @Output() viewFile = new EventEmitter<string>();
  @Output() fileSelected = new EventEmitter<{ files: File[], card: string }>();
  readonly ALLOWED_EXTENSIONS = ['pdf'];
  readonly MAX_FILE_SIZE_MB = 25;

  errorMessages: string[] = [];


  selectedFile: File | null = null;
  selectedFiles: File[] = [];

  isDragging = false;
  @Input() resetInput: boolean = false;


  get isMultiFileCard(): boolean {
    return this.card === 'Autres justificatifs (CDC, Etude de dimensionnement, etc.)' || this.card === 'Autres justificatifs'; // Use your actual key to identify the multi-file card
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['resetInput']?.currentValue) {
      this.clearInput();
    }
  }

  clearInput() {
    this.selectedFile = null;
    this.selectedFiles = [];
    const inputEl = document.getElementById(`file-input-${this.card}`) as HTMLInputElement;
    if (inputEl) {
      inputEl.value = '';
    }
  }

  onViewFile() {
    this.viewFile.emit(this.card);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave() {
    this.isDragging = false;
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    const files = Array.from(input.files);
    const validFiles = files.filter(file => this.isValidFile(file));
    const invalidFiles = files.filter(file => !this.isValidFile(file));

    this.handleErrors(invalidFiles);

    if (validFiles.length === 0) return;

    if (this.isMultiFileCard) {
      this.selectedFiles.push(...validFiles);
      this.fileSelected.emit({ card: this.card, files: validFiles });
    } else {
      this.selectedFile = validFiles[0];
      this.fileSelected.emit({ card: this.card, files: [validFiles[0]] });
    }
    this.clearInput();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (!files || files.length === 0) return;

    const droppedFiles = Array.from(files);
    const validFiles = droppedFiles.filter(file => this.isValidFile(file));
    const invalidFiles = droppedFiles.filter(file => !this.isValidFile(file));

    this.handleErrors(invalidFiles);

    if (validFiles.length === 0) return;

    if (this.isMultiFileCard) {
      this.selectedFiles.push(...validFiles);
      this.fileSelected.emit({ files: validFiles, card: this.card });
    } else {
      this.selectedFile = validFiles[0];
      this.fileSelected.emit({ files: [validFiles[0]], card: this.card });
    }
    this.clearInput();
  }

  triggerFileSelect(input: HTMLInputElement) {
    input.click();
  }

  getFileExtension(filename: string): string {
    return filename.split('.').pop() || '';
  }

  getFileSizeInMB(bytes: number): string {
    return (bytes / (1024 * 1024)).toFixed(2);
  }

  private isValidFile(file: File): boolean {
    const extension = this.getFileExtension(file.name).toLowerCase();
    const sizeInMB = file.size / (1024 * 1024);
    return this.ALLOWED_EXTENSIONS.includes(extension) && sizeInMB <= this.MAX_FILE_SIZE_MB;
  }

  private handleErrors(files: File[]) {
    this.errorMessages = files.map(file => {
      const extension = this.getFileExtension(file.name).toLowerCase();
      const size = (file.size / (1024 * 1024)).toFixed(2);
      if (!this.ALLOWED_EXTENSIONS.includes(extension)) {
        return `Extension non autorisée : ${file.name}`;
      }
      if (parseFloat(size) > this.MAX_FILE_SIZE_MB) {
        return `Fichier trop volumineux (${size} Mo) : ${file.name}`;
      }
      return '';
    }).filter(msg => msg !== '');
  }


}
